import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-phone-shaixuan",
  "use": "icon-phone-shaixuan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-phone-shaixuan\"><path d=\"M892.18 47.373H131.876c-30.375 0-42.281 23.58-42.281 42.222 0 22.477 21.14 42.281 21.14 42.281l295.677 337.9v485.767s0 21.083 31.652 21.083c13.88 0 31.711-21.083 31.711-21.083l147.81-126.785V469.776l295.677-337.9s21.083-18.47 21.083-42.281c0-18.643-13.126-42.222-42.164-42.222z\" fill=\"\" p-id=\"5471\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/phone-shaixuan.svg
// module id = eL63
// module chunks = 42